<template>
  <!-- Estesoft.App DynamicBootstrapModal'ın Vega/BS4 uyarlaması: .close + &times;, kısmi options
       birleştirilir, gövde kilidi modalService'ten (modal-open), sıraya göre z-index. -->
  <div :style="{ position: 'absolute', zIndex: zIndex }">
    <div class="modal-backdrop fade show" :style="opts.backdropStyle"></div>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true"
         @mousedown="onMousedown" @mouseup="onMouseup">
      <div class="modal-dialog modal-dialog-centered" :class="opts.size" :style="opts.dialogStyle" role="document">
        <div ref="content" class="modal-content" :style="opts.contentStyle">
          <div v-if="opts.header.show" class="modal-header">
            <slot name="header">
              <h5 class="modal-title">{{ opts.header.title }}</h5>
              <button type="button" class="close" aria-label="Close" @click="handleClose">
                <span aria-hidden="true">&times;</span>
              </button>
            </slot>
          </div>
          <div class="modal-body p-0">
            <component :is="component" v-bind="componentProps" />
          </div>
          <div v-if="opts.footer.show" class="modal-footer">
            <slot name="footer">
              <button type="button" class="btn btn-secondary" @click="handleClose">{{ opts.footer.title }}</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { lockModalBody, unlockModalBody, pushModal, removeModal } from '../../../utils/modalService';

  const DEFAULT_OPTIONS = {
    header: { show: true, title: '' },
    footer: { show: true, title: '' },
    size: 'modal-lg', // "modal-lg", "modal-sm", "modal-xl"
    // Vega ekleri (eski $modal API uyumu için plugins/modal.js doldurur)
    closeOnEsc: false,
    clickToClose: true,
    dialogStyle: null,
    contentStyle: null,
    backdropStyle: null
  };

  export default {
    name: 'DynamicBootstrapModal',
    emits: ['onClose'],
    props: {
      component: [Object, Function, String],
      componentProps: {
        type: Object,
        default: () => ({}),
      },
      options: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        zIndex: 1040,
        mousedownOutside: false
      };
    },
    computed: {
      opts() {
        const options = this.options || {};
        return {
          ...DEFAULT_OPTIONS,
          ...options,
          header: { ...DEFAULT_OPTIONS.header, ...(options.header || {}) },
          footer: { ...DEFAULT_OPTIONS.footer, ...(options.footer || {}) }
        };
      }
    },
    created() {
      this.stackEntry = { onEscape: this.onEscape };
    },
    mounted() {
      lockModalBody();
      this.zIndex = pushModal(this.stackEntry);
    },
    beforeUnmount() {
      removeModal(this.stackEntry);
      unlockModalBody();
    },
    methods: {
      handleClose() {
        this.$emit("onClose");
      },
      onEscape() {
        if (this.opts.closeOnEsc) this.handleClose();
      },
      isOutsideContent(target) {
        return !!this.$refs.content && !this.$refs.content.contains(target);
      },
      onMousedown(event) {
        this.mousedownOutside = this.isOutsideContent(event.target);
      },
      /* Arka plana tıklama: basma ve bırakma içeriğin dışında olmalı (içeride başlayan metin
         seçimi dışarıda bırakılınca kapanmaz). */
      onMouseup(event) {
        const outside = this.mousedownOutside && this.isOutsideContent(event.target);
        this.mousedownOutside = false;
        if (!outside || !this.opts.clickToClose) return;
        const selection = window.getSelection().toString();
        if (!selection) {
          this.handleClose();
        }
      }
    },
  };
</script>
